import { makeStyles } from "@mui/styles";

export const styles = makeStyles({
  container: {
    width: "100%",
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  containLoader: {
    margin: " 5vh",
  },
  title: {
    color: "#102f51",
    fontWeight: "600",
    textAlign: "center",
    fontSize: "clamp(1rem, 1.5vw, 3rem)",
  },
  loaderContainer: {
    alignSelf: "center",
    height: "100vh",
    display: "flex",
    justifyContent: "center",
  },
});
